<template>
  <div class="assets-wrap page-padding"
       @click="groupList = false">
    <ioc-table ref="crud"
               v-model="assets"
               :data="tableData"
               :option="option"
               :page="page"
               @row-save="handleCreate"
               @row-update="handleUpdate"
               @row-cancle="closeDialog"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               @selection-change="handleSelectionChange">
      <!-- 搜索框 自定义 -->
      <template slot="search_areaName">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    @click.stop.native="areaTreeShow('search')"
                    class="bukongObject"
                    v-model="searchParams.areaName"></el-input>
          <div v-if="groupList"
               style="position:absolute;bottom:-255px;width:100%;z-index:999999;height:250px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);">
            <div style="position:relative;height:80%;">
              <app-camers-group type="2"
                                ref="areaTree"
                                url="/cms/area/queryAreaByAccountName.json"
                                :isRequired="true"
                                @changeCamersGroup="searchAreasChange"
                                style="width:100%;height:100%;position;inherit;right:-10px;top:0">
              </app-camers-group>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                         @click="confirmCamers('search')">{{ $t('taskCenter.button.conform') }}</el-button>
              <el-button type="info"
                         @click="cancelCamers('search')">{{ $t('taskCenter.button.cancel') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button v-auth="'/assets/assetsManage:add'"
                   type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-plus"
                   @click="handleAddAssets">
          {{ $t('workGroup.button.add') }}
        </el-button>
        <el-button v-auth="'/assets/assetsManage:delete'"
                   type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-delete"
                   @click="handelDelAssets">
          {{ $t('workGroup.button.batchDel') }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip v-show="scope.row.fireassetType === '12'"
                    class="item"
                    effect="dark"
                    content="关联资产明细"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button v-auth="'/assets/assetsManage:update'"
                     style="font-size: 16px; position: relative; top: 1px;"
                     type="text"
                     icon="el-icon-link"
                     @click="handleLink(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button v-auth="'/assets/assetsManage:update'"
                     type="text"
                     icon="iconfont icon-xiugai"
                     @click="handleEdit(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="详情"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-Detail"
                     @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button v-auth="'/assets/assetsManage:delete'"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDel(scope.row, scope.index)"></el-button>
        </el-tooltip>
      </template>
      <!-- 表格列 自定义 -->
      <template slot="deviceQrCode"
                slot-scope="scope">
        <span @click="showCode(scope.row)">
          <vue-qr :text="'NAME|' + scope.row.fireassetName + '|' + scope.row.fireassetType"
                  :size="50"
                  :margin="5"></vue-qr>
        </span>
      </template>
      <!-- 新增/修改表单 自定义 -->
      <template slot="fileCodeForm"
                slot-scope="scope">
        <div class="upload_img">
          <el-upload action=""
                     v-model="fileList"
                     list-type="picture-card"
                     :on-exceed="fileCount"
                     :on-change="
              (file, fileList) => {
                handleChange(file, fileList, scope.row)
              }
            "
                     :on-remove="
              (file, fileList) => {
                handleRemove(file, fileList, scope.row)
              }
            "
                     :auto-upload="false"
                     :limit="1"
                     ref="upload"
                     :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </template>
      <template slot="statusForm">
        <el-select v-model="form.status"
                   placeholder="请选择使用状态">
          <el-option v-for="item in statusOption"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"> </el-option>
        </el-select>
      </template>
      <template slot="longitudeForm">
        <el-input v-model="form.longitude"
                  placeholder="请输入纬度"></el-input>
      </template>
      <template slot="latitudeForm">
        <el-input v-model="form.latitude"
                  class="position-set"
                  style="width:200px"
                  placeholder="请输入纬度"></el-input>
        <el-button type="text"
                   size="small"
                   class="iconfont icon-position map-choose"
                   @click="openMap"> </el-button>
      </template>
      <template slot="areaNameForm">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    @click.native="areaTreeShow('add')"
                    class="bukongObject"
                    v-model="form.areaName"></el-input>
          <div v-if="addGroupList"
               style="position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);background-color:rgb(23, 28, 40)">
            <div style="position:relative;height:80%;">
              <app-camers-group type="3"
                                ref="areaTree"
                                url="/cms/area/queryAreaByAccountName.json"
                                :isRequired="true"
                                :multiCheck="false"
                                @current-change="currentChange"
                                style="width:100%;height:100%;position;inherit;right:-10px;top:0">
              </app-camers-group>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                         @click="confirmCamers('add')">{{ $t('taskCenter.button.conform') }}</el-button>
              <el-button type="info"
                         @click="cancelCamers('add')">{{ $t('taskCenter.button.cancel') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 查看详情表单 自定义 -->
      <template slot="fileCodeView"
                slot-scope="scope">
        <img :src="getImgPath(scope.row.fileCode)"
             @click="showViewer(scope.row.fileCode, $event)"
             onerror="this.src='/images/theme/newDark/default.png'"
             style="height:50px;width:50px" />
      </template>
      <template slot="viewFormSet"
                slot-scope="scope">
        <label>设备二维码</label>
        <span class="qrCode">
          <vue-qr :text="'NAME|' + scope.row.fireassetName + '|' + scope.row.fireassetType"
                  :size="60"
                  :margin="5"></vue-qr>
        </span>
      </template>
    </ioc-table>
    <!-- 引入gis地图 -->
    <el-dialog :title="$t('taskCenter.label.mapChoice')"
               :visible.sync="showMap"
               v-dialogDrag
               @close="mapClose"
               @click="mapCancleOpt">
      <div id="mini-map"></div>
      <!-- 底部操作按钮 -->
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="mapConfirmOpt">{{ $t('taskCenter.button.conform') }}</el-button>
        <el-button @click="mapCancleOpt">{{ $t('taskCenter.button.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 二维码放大 -->
    <el-dialog title="设备二维码"
               :visible.sync="showQrCode"
               v-dialogDrag
               width="300px">
      <div class="qr_big"
           ref="printTest">
        <vue-qr :text="'NAME|' + rowInfo.fireassetName + '|' + rowInfo.fireassetType"
                :size="200"
                id="printTest"
                :margin="5"></vue-qr>
      </div>
      <div class="qr_big">
        <span>{{ rowInfo.fireassetName }}</span>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <!-- <el-button type="primary"
                   v-print="'#printTest'">打印</el-button> -->
        <el-button type="primary"
                   @click="printTest">打印</el-button>
        <el-button @click="showQrCode = false">{{ $t('taskCenter.button.cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联资产明细"
               :visible.sync="linkDialog"
               v-dialogDrag
               width="605px">
      <el-transfer v-if="linkDialog"
                   v-model="linkAssetsModel"
                   :data="linkAssetsData"
                   @change="rightChange"
                   @right-check-change="rightCheckChange"
                   :props="{
          key: 'fireassetName',
          label: 'fireassetName',
        }">
      </el-transfer>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="linkDialog = false">{{ $t('taskCenter.button.cancel') }}</el-button>
        <el-button type="primary"
                   @click="linkAssetsUpdate">{{ $t('taskCenter.button.conform') }}</el-button>
      </span>
    </el-dialog>
    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
  </div>
</template>
<script>
import { api } from '../api'
import tableOption from '../const/manageOption'
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from '$utils'
import appCamersGroup from '@components/app-camera-group'
import vueQr from 'vue-qr'
export default {
  components: {
    appCamersGroup,
    vueQr,
  },
  data () {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      linkDialog: false,
      linkAssetsModel: [],
      linkAssetsData: [],
      selectLinkAssets: [],
      selectFireassetName: '',
      assets: {},
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      searchParams: {},
      option: tableOption(this),
      accountGroupsChecked: [],
      groupList: false,
      addGroupList: false,
      assetsTypeExist: [],
      assetsType: Dic.find('SENU077'),
      showMap: false,
      showQrCode: false,
      rowInfo: {},
      form: {
        fileCode: '',
        areaName: '',
        area: '',
        longitude: null,
        latitude: null,
        status: null,
      },
      fileList: [], // 上传图片数组
      imgFileList: [], // 保存名单中上传图片数组
      formState: 1, // 1 新增 2 修改
      statusOption: [
        {
          label: '库存中',
          value: 0,
        },
        {
          label: '使用中',
          value: 1,
        },
      ],
    }
  },
  watch: {
    imgFileList: {
      handler (newValue, oldValue) {
        // this.form.fileList = newValue
      },
      deep: true,
    },
    fileList: {
      handler (newValue, oldValue) {
        // this.form.fileList = newValue
      },
      deep: true,
    },
  },
  mounted () {
    this.getList()
  },
  created () { },
  methods: {
    inited (viewer) {
      this.viewerInstance = viewer
    },
    showViewer (imgs, e) {
      this.viewerPhotos = [e.target.src.indexOf('default/default.png') == -1 ? e.target.src + "&sourceFileFlag=1" : e.target.src];
      this.viewerInstance.show()
    },
    getImgPath (item) {
      return item ? Bus.imgPath(item) : ''
    },
    handleSearchReset () {
      this.searchParams.areas = []
      this.getList()
    },
    getList () {
      const params = {}
      params.pageNo = this.page.currentPage
      params.pageSize = this.page.pageSize
      params.fireassetName = this.searchParams.fireassetName
      params.fireassetType = this.searchParams.fireassetType
      params.areas = this.searchParams.areas
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(api.assetsManage.queryAssetsList, params).then((response) => {
        setTimeout(() => {
          loading.close()
        }, 500);

        if (!response.success) {
          this.$message.error(response.msgContent)
          return
        }
        this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : []
        this.page.total = response.returnObj ? response.returnObj.total : 0
        this.$refs.crud.selectClear()
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange (param) {
      this.searchParams = param
      this.page.currentPage = 1
      this.getList()
    },
    handleAddAssets () {
      this.$refs.crud.rowAdd()
      this.formState = 1 // 新增
    },
    handleView (row, index) {
      this.$refs.crud.rowView(row, index)
    },
    handleLink (row, index) {
      this.selectFireassetName = row.fireassetName
      api.assetsManage.queryOutHoseboxAssetList(row.fireassetName, this)
      this.linkDialog = true
    },
    handleEdit (row, index) {
      row.fireassetType = Number(row.fireassetType)
      this.rowInfo = row
      this.form.status = Number(row.status)
      this.form.longitude = row.longitude
      this.form.latitude = row.latitude
      this.form.areaName = row.areaName
      this.fileList = []
      this.fileList.push({
        url: this.getImgPath(row.fileCode),
        status: 'update',
        fileCode: row.fileCode,
      })
      this.$nextTick(() => {
        this.$refs.crud.rowEdit(this.rowInfo, index)
      })
    },
    handleDel (row) {
      const params = {
        fireassetNames: [row.fireassetName],
      }
      this.$confirm('您确定删除该消防资源吗?', '删除确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$fetch(api.assetsManage.deleteAssetsInfo, params).then((response) => {
          if (response && response.success) {
            this.$message.success(response.msgContent)
            this.getList()
          } else {
            this.$message.error(response.msgContent)
          }
        })
      })
    },
    handelDelAssets () {
      if (this.checkedAssets.length === 0) {
        this.$message({
          type: 'warning',
          duration: 2000,
          message: '请选择你要删除的资产',
        })
        return
      }
      const fireassetName = []
      this.$confirm('您确定删除这些资产吗?', '删除确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$fetch(api.assetsManage.deleteAssetsInfo, { fireassetNames: this.checkedAssets }).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return
          } else {
            this.$message.success(response.msgContent)
            this.getList()
          }
        })
      })
    },
    // 新增消防资产
    handleCreate (addInfo, done) {
      console.log('新增信息', addInfo)
      this.$refs['crud'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          console.log('imgFileList', this.imgFileList)
          if (!this.imgFileList || !this.imgFileList.length) {
            this.$message.warning('请上传资产图片')
            return
          }
          let formData = new FormData()
          this.imgFileList.map((item) => {
            formData.append('files', item.raw)
          })
          this.$fetch(api.assetsManage.batchFileload, formData).then((res) => {
            this.form.fileCode = res.returnObj[0].fileId
            this.form.status = this.form.status === 1 ? this.form.status : 0
            this.form.productionTime = Dates.format(addInfo.productionTime, 'yyyy-MM-dd')
            const params = Object.assign(addInfo, this.form)
            // addInfo.fileCode = res.returnObj[0].fileId
            this.$fetch(api.assetsManage.addAssetsInfo, params).then((res) => {
              if (res && res.success) {
                this.getList()
                this.$message.success(res.msgContent)
                this.form.areaName = ''
                this.form.area = ''
                this.form.status = null
                this.form.longitude = null
                this.form.latitude = null
              } else {
                this.$message.error(res.msgContent)
              }
              this.fileList = []
              done()
            })
          })
        }
      })
    },
    handleUpdateimg (params, done) {
      this.$fetch(api.assetsManage.updateAssetsInfo, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent)
          this.form.areaName = ''
          this.form.area = ''
          this.form.status = null
          this.form.longitude = null
          this.form.latitude = null
          this.getList(this.page)
        } else {
          this.$message.error(res.msgContent)
        }
        done()
      })
    },
    // 修改消防资产
    handleUpdate (updateInfo, done) {
      console.log('updateInfo', updateInfo)
      this.form.fileCode = updateInfo.fileCode
      this.form.productionTime = Dates.format(updateInfo.productionTime, 'yyyy-MM-dd ')
      const params = Object.assign(updateInfo, this.form)
      if (typeof updateInfo.fileCode != 'string') {
        let formData = new FormData()
        updateInfo.fileCode.map((item) => {
          formData.append('files', item.raw)
        })
        this.$fetch(api.assetsManage.batchFileload, formData).then((res) => {
          params.fileCode = res.returnObj[0].fileId
          this.handleUpdateimg(params, done)
        })
      } else {
        this.handleUpdateimg(params, done)
      }
    },
    closeDialog () {
      this.fileList = []
      this.form.areaName = ''
      this.form.area = ''
      this.form.status = null
      this.form.longitude = null
      this.form.latitude = null
    },
    rightCheckChange (select) {
      this.selectLinkAssets = select
    },
    rightChange (val) {
      this.selectLinkAssets = []
    },
    linkAssetsUpdate () {
      // this.linkDialog = false
      if (this.selectLinkAssets.length <= 0) {
        this.$message.warning('请选择至少一条关联资产')
        return
      }
      api.assetsManage.updateHoseboxAssetList(this)
    },
    handleSelectionChange (items) {
      this.checkedAssets = items.map((item) => {
        return item.fireassetName
      })
    },
    // 新增时 选择区域
    currentChange (data) {
      this.form.areaName = data.areaDevGroupName
      this.form.area = data.areaDevGroupCode
    },
    searchAreasChange (data) {
      this.searchParams.areaName = ''
      this.searchParams.areas = []
      const areaName = []
      data.map((val) => {
        areaName.push(val.areaDevGroupName)
        this.searchParams.areas.push(val.areaDevGroupCode)
      })
      this.searchParams.areaName = areaName.toString()
    },
    areaTreeShow (param) {
      if (param === 'search') {
        this.groupList = true
      } else {
        this.addGroupList = true
      }
    },
    confirmCamers (param) {
      if (param === 'search') {
        this.groupList = false
      } else {
        this.addGroupList = false
      }
    },
    cancelCamers (param) {
      if (param === 'search') {
        this.groupList = false
      } else {
        this.addGroupList = false
        this.form.areaName = ''
        this.form.area = ''
      }
    },
    openMap () {
      this.showMap = true
      this.$nextTick(() => {
        this.$map.showMap2D(this.initMap)
      })
    },
    initMap () {
      this.$map.MapInstance2D.setMapOption()
      this.$map.MapInstance2D.resetMapStyle('mini-map')
      this.$map.MapInstance2D.getLocation(this.getLocationCB)
    },
    getLocationCB (event) {
      this.point = event
      let option = [
        {
          id: 'point_' + new Date().getTime(),
          coord: this.point,
          src: 'images/theme/newDark/map/resource/position_red.png',
        },
      ]
      this.$map.MapInstance2D.clearPoint()
      this.$map.MapInstance2D.addMarket(option)
    },
    showCode (rowInfo) {
      this.showQrCode = true
      this.rowInfo = rowInfo
    },
    mapConfirmOpt () {
      this.form.longitude = Number(this.point[0]).toFixed(10)
      this.form.latitude = Number(this.point[1]).toFixed(10)
      this.showMap = false
    },
    mapClose () {
      this.$map.hideMap2D()
    },
    // 点击地图框中的取消操作
    mapCancleOpt () {
      this.showMap = false
      this.$map.hideMap2D()
    },
    // 判断上传文件个数
    fileCount (file, fileList) {
      this.$message.warning(this.$t('personMg.message.upWarn'))
    },
    // 添加图片
    handleChange (file, fileList, row) {
      console.log('fileList', fileList, row)
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList)
        return false
      }
      this.imgFileList = fileList
      row.fileCode = fileList
    },
    validImg (file) {
      const fileName = file.name
      const type = fileName.slice(fileName.indexOf('.') + 1, fileName.length)
      const imgArr = ['jpg', 'png', 'jpeg', 'jpe', 'dib', 'bmp', 'JPG', 'PNG', 'JPEG', 'JPE', 'DIB', 'BMP']
      let isJPG = null
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true)

      if (!isJPG) {
        this.$message.error(this.$t('personMg.message.formatWarn'))
        return false
      }
      const Size = 1024 * 1024 * 4
      if (file.size > Size) {
        this.$message.error(this.$t('personMg.message.sizeWarn'))
        return false
      }
      return true
    },
    deleteImg (file, fileList) {
      if (this.formState === 2) {
        if (file.status === 'update') {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url
          })
          this.fileList.splice(index, 1)
        } else {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url
          })
          fileList.splice(index, 1)
        }
      } else {
        let index = this.fileList.findIndex((item) => {
          return item.url === file.url
        })
        fileList.splice(index, 1)
      }
    },
    // 删除图片
    handleRemove (file, fileList, row) {
      if (this.formState === 2) {
        if (file.status === 'update') {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url
          })
          this.fileList.splice(index, 1)
        }
      }
      this.imgFileList = fileList
      row.fileCode = fileList
    },
    printTest () {
      let qrSrc = this.$refs.printTest.getElementsByTagName("img")[0].src;
      let newWin = window.open("");
      newWin.document.body.innerHTML = `<img src='${qrSrc}' />`;
      newWin.document.close(); //在IE浏览器中使用必须添加这一句
      newWin.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(() => {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
      // window.document.body.innerHTML = `<img src='${qrSrc}' />`;
      // window.print(); //打印
    }
  },
}
</script>
<style lang="scss">
@import "../style/manage.scss";
</style>
